import "core-js/modules/es.array.push.js";
import wineComponent from "@/components/products/WineComponent.vue";
export default {
  name: "UserCellarProductDetails",
  data: function data() {
    return {
      cellarWine: "",
      returnRoute: "",
      routeParam: ""
    };
  },
  created: function created() {
    if (typeof this.$route.params != "undefined" && typeof this.$route.params.cellarWine != "undefined") {
      this.cellarWine = this.$route.params.cellarWine;
    } else {
      this.$router.push({
        name: "userCellar"
      });
    }
    this.idWine = this.$route.params.cellarWine.wine.id_wine;
    this.searchCriterias = this.$route.params.searchCriterias;
    this.returnRoute = "userCellar";
    this.routeParam = null;
  },
  components: {
    wine: wineComponent
  },
  props: ["loggedUserData"]
};